export default {"src":"/_next/static/media/arrow-right.ccb1d4f2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};